import { InspectionSection } from './inspectionSection.model';
import { Icon } from './icon.model';

import * as _ from 'lodash';

export class InspectionFolder extends InspectionSection {
  public section: InspectionSection;
  public sectionId: string;
  public parent: InspectionFolder;
  public icons: Icon[] = [];

  public type = 100;

  constructor(public id: string, public name: string, public description: string) {
    super(id, name, description);
    this.icons = [];
  }

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    return this.name == null || this.name.toLowerCase().indexOf(queryToLower) !== -1;
  }
}
